

















































































import Vue, { PropType } from 'vue';
import CreateInlinePixelForm from '@/components/campaign/targets/retarget/inlinePixel/CreateInlinePixelForm.vue';
import { Pixel } from '@/types/audience/audience';

export default Vue.extend({
  name: 'InlinePixel',
  components: { CreateInlinePixelForm },
  props: {
    pixelList: {
      type: Array as PropType<Array<Pixel>>,
      default: () => [],
    },
  },
  methods: {
    showPixelCode(pixel: Pixel) {
      this.pixel = pixel;
      this.openModal();
    },
    copyPixelCode(publicKey) {
      this.copyToClipboard = publicKey;
    },
    openModal() {
      this.modal = true;
    },
    closeModal() {
      setTimeout(() => (this.pixel = {}), 100);
      this.modal = false;
    },
    async addPixel(pixelName: string) {
      if (pixelName.trim()) {
        const form = new FormData();
        form.append('name', pixelName);
        const pixel = await this.$store.dispatch('audience/createPixel', form);
        this.pixel = pixel.data;
        this.updatePixel();
        return;
      }
      this.closeModal();
    },
    updatePixel() {
      this.$emit('update', this.pixel);
    },
    deletePixel(id) {
      this.$store.dispatch('deletePixel', { id });
    },
  },
  data: () => {
    return {
      modal: false,
      pixel: {},
      copyToClipboard: '',
    };
  },
});
